import React from 'react';
import AbstractInput from '../AbstractInput';
import protectedProps from '../AbstractInput/protectedProps';

const TextInput = (props) => (
  <AbstractInput {...props} />
);

export default protectedProps(TextInput);
